export default __webpack_public_path__ + "media/images/icons/facebook-c719a013d9be7d611d2dd9e1fa4ecf06.svg";